"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnapshotClient = exports.FileExportStatus = exports.SnapshotExportType = void 0;
const tslib_1 = require("tslib");
const pako_1 = tslib_1.__importDefault(require("pako"));
const authenticated_client_1 = require("./authenticated.client");
var SnapshotExportType;
(function (SnapshotExportType) {
    SnapshotExportType["Png"] = "png";
    SnapshotExportType["Pdf"] = "pdf";
    SnapshotExportType["FullPng"] = "full-png";
})(SnapshotExportType = exports.SnapshotExportType || (exports.SnapshotExportType = {}));
var FileExportStatus;
(function (FileExportStatus) {
    FileExportStatus["InProgress"] = "inProgress";
    FileExportStatus["Success"] = "success";
    FileExportStatus["Error"] = "error";
})(FileExportStatus = exports.FileExportStatus || (exports.FileExportStatus = {}));
class SnapshotClient extends authenticated_client_1.AuthenticatedClient {
    getSnapshotsByPageId(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString(request);
            const url = `/v1/projects/${projectId}/snapshots?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSdkSnapshotsByPageId(projectId, request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const queryString = this.getQueryString(request);
            const url = `/v1/projects/${projectId}/snapshots/sdk?${queryString}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getScreenshotBySnapshotId(projectId, snapshotId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/screenshot`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    findSnapshotsByZoningId(projectId, zoningId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/snapshots`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    findSnapshotsByZoningIdV2(projectId, zoningId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/zonings/${zoningId}/snapshots`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    create(projectId, snapshots, zoningId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/snapshots`;
            yield this.httpPost(url, snapshots);
        });
    }
    createV2(projectId, snapshots, zoningId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/zonings/${zoningId}/snapshots`;
            const response = yield this.httpPost(url, snapshots);
            return response.payload;
        });
    }
    createV3(projectId, zoningId, snapshots) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v3/projects/${projectId}/zonings/${zoningId}/snapshots`;
            const response = yield this.httpPost(url, snapshots);
            return response.payload;
        });
    }
    createRawDataV3(projectId, snapshots) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v3/projects/${projectId}/snapshots/raw-data`;
            const form = new FormData();
            for (const snapshot of snapshots) {
                form.append('metadata', JSON.stringify(snapshot.metadata));
                const compressedData = pako_1.default.gzip(JSON.stringify(snapshot.rawData), { to: 'string' });
                form.append('files', new Blob([compressedData], { type: 'application/octet-stream' }));
            }
            return this.httpPost(url, form);
        });
    }
    update(projectId, snapshots, zoningId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/zonings/${zoningId}/snapshots`;
            yield this.httpPut(url, snapshots);
        });
    }
    updateNameBySnapshotId(projectId, name, snapshotId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/snapshots/${snapshotId}/name`;
            yield this.httpPut(url, { name });
        });
    }
    updateKeepOriginalUrlBySnapshotId(projectId, keepOriginalUrl, snapshotId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/snapshots/${snapshotId}/keepOriginalUrl`;
            yield this.httpPut(url, { keepOriginalUrl });
        });
    }
    findLinkedZoningsBySnapshotId(projectId, snapshotId, fields = ['name', 'updatedAt']) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/zonings?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return { zonings: response.payload || [] };
        });
    }
    deleteSnapshotById(projectId, snapshotId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}`;
            yield this.httpDelete(url);
        });
    }
    deleteWithZonings(projectId, snapshotId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/with-zonings`;
            yield this.httpDelete(url);
        });
    }
    exportSnapshot(projectId, snapshotId, snapshot, type, viewportHeight, viewportWidth) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/export/${type}`;
            const payload = { snapshot, viewportHeight, viewportWidth };
            const response = yield this.executeRaw('post', url, payload);
            return response.data;
        });
    }
    exportSnapshots(projectId, snapshotId, type, snapshots) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/${snapshotId}/export/${type}`;
            const response = yield this.executeRaw('post', url, snapshots);
            return response.data;
        });
    }
    exportSnapshotsV2(projectId, type, snapshots) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/export/${type}`;
            const response = yield this.executeRaw('post', url, snapshots);
            return response.data;
        });
    }
    exportSnapshotsV2Async(projectId, type, snapshots) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/snapshots/export/${type}`;
            const response = yield this.httpPost(url, snapshots);
            return response.payload;
        });
    }
    exportSnapshotsV3Async(projectId, type, exports) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v3/projects/${projectId}/snapshots/export/${type}`;
            const compressedData = pako_1.default.gzip(JSON.stringify(exports), { to: 'string' });
            const response = yield this.httpPost(url, compressedData, {
                headers: {
                    'content-type': 'application/octet-stream',
                    'content-encoding': 'gzip',
                },
            });
            return response.payload;
        });
    }
    getSnapshotExportStatus(projectId, snapshotExportId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/snapshots/export/status/${snapshotExportId}`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
    getSnapshotDownload(projectId, snapshotExportId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v2/projects/${projectId}/snapshots/export/download/${snapshotExportId}`;
            const response = yield this.executeRaw('get', url, null);
            return response.data;
        });
    }
    generateRenderingToken(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/projects/${projectId}/snapshots/rendering-token`;
            const response = yield this.httpGet(url);
            return response.payload;
        });
    }
}
exports.SnapshotClient = SnapshotClient;
//# sourceMappingURL=snapshot.client.js.map